import { BASE_API_URL, handleAPIResponse } from './Base';

export async function getDatasources() {
  const response = await fetch(`${BASE_API_URL}/datasources`)
  return await handleAPIResponse(response);
}
